import { Link } from "@ds/react";
import Modal from "components/Modal";
import { getEnvVar } from "utils/environment";

const UsoDadosModal = (props) => {
  return (
    <Modal
      {...props}
      title="Saiba mais sobre o uso dos seus dados. Pode confiar!"
      closeActionProps={{
        text: "Fechar",
      }}
    >
      <span>
        Os dados solicitados aqui são necessários para ativarmos o seu título e são obrigatórios
        para atendermos às determinações do nosso regulador SUSEP e as legislações
        aplicáveis.{" "}
      </span>

      <span>
        Também podemos usar os seus dados para te oferecer algum novo produto ou benefício, sempre
        respeitando a sua expectativa.
      </span>

      <span>
        Saiba mais detalhes de como utilizamos seus dados pessoais em nossa{" "}
        <Link
          role="button"
          variant="primary-sm-02"
          href={getEnvVar("AA_CAPITALIZACAO_PORTAL_PRIVACIDADE")}
          target="_blank"
          rel="noreferrer"
        >
          Política de Privacidade.
        </Link>
      </span>
    </Modal>
  );
};

export default UsoDadosModal;
